export default __webpack_public_path__ + "static/media/joystick.f8d03444.svg";